export default __webpack_public_path__ + "static/media/sb-white.d49fadcb.svg";